module.exports = __webpack_public_path__ + "img/r-max.02de2886.png";